
import { MultiPageGuideCollection } from "data/MultiPageGuideCollection";
import { ActionResult } from "data/StepWithAction";

import { SinglePageGuideCollection } from "../SinglePageGuideCollection";

const editDocumentGuide: SinglePageGuideCollection = {
    stageNumber: 1,
    cookieName: 'document-editor-guide-stage-1',
    navigateTo: '/documents/edit/new',
    steps: [
        {
            title: 'Welcome to the Editor!',
            intro: 'This is where the magic happens!',
        },
        {
            element: '.headline-textbox',
            intro: 'To get started, enter a title for your article.',
            position: 'bottom-middle-aligned',
            isActionCompleted: (): ActionResult => {
                const titleInput = document.querySelector('.headline-textbox') as HTMLInputElement | null;
                const isCompleted = titleInput !== null && titleInput.value.trim() !== '';
                return { isCompleted, message: "" };
            }
        },
        {
            element: '.short-description',
            intro: 'Then, enter a brief description here.',
            position: 'bottom-middle-aligned',
        },
        {
            element: '.image-label-container',
            intro: 'Next, upload a cover image.',
            position: 'top',
        },
        {
            element: '.doc-tabs',
            intro:
                'Change tabs to edit secondary info such as the publication date, the blog post category, and social media posts for the article.',
            position: 'top',
        },
        {
            element: '.rich-editor',
            intro: 'This is your distraction free writing surface, where your masterpiece comes to life!',
            position: 'right',
        },
        {
            element: '.ai-writing-tab',
            intro: 'This is where your AI writing assistant can be found!  Click <strong>Run</strong> on any prompt chain to generate content!  Click <strong>Details</strong> to see the prompt chain template.',
            position: 'left',
        },
        {
            element: '.editor-sidebar',
            intro: 'Later, when reviewers leave comments on your work, you will see them here.',
            position: 'left',
        },
        {
            element: '.action-buttons',
            intro: "Finally, don't forget to save your work by clicking here!",
            position: 'right',
        }
    ]
}

const editDocumentGeneralGuide: MultiPageGuideCollection = {
    title: 'Document Editor Guide',
    key: 'document-editor-guide',
    steps: [editDocumentGuide],
    onCompleteNavigateTo: '/documents/edit/new'
};

export default editDocumentGeneralGuide;